const ENV_WORKSPACE_ID =
  typeof process !== "undefined"
    ? process.env.STUDIO_WORKSPACE_ID || (process as any)?.env?.REACT_APP_STUDIO_WORKSPACE_ID
    : undefined;

export const DEFAULT_WORKSPACE_ID = ENV_WORKSPACE_ID && ENV_WORKSPACE_ID.trim().length ? ENV_WORKSPACE_ID.trim() : "default";
